import React from 'react';
import clsx from 'clsx';
import { connect } from 'react-redux';
import { firstErrorMessage } from '@/utils/errors';
import Filter from '@/components/Filter';
import VisibilityFilterToggles from '@/components/buttons/VisibilityFilterToggles';
import { fetchRequestCohorts, updateRequestCohortsFilter, updateRequestCohortsFlags } from '../actions';
import { newRequest, resolveRequestWorkflow } from '../../state/state';

const RequestCohortsFilters = ({
  category,
  code,
  privateFlag,
  internalFlag,
  updateFlags,
  filterTerm,
  updateFilterTerm,
  fetchData,
  readErrors,
  className,
  fluid,
}) => (
  <Filter
    fluid={fluid}
    className={clsx('aridhia-request-cohorts-filter', className)}
    filterTerm={filterTerm}
    updateFilter={({ value }) => updateFilterTerm(category, code, value)}
    error={firstErrorMessage(readErrors)}
    onFilter={() => fetchData(category, code, 1, null, false)}
    label={(
      <VisibilityFilterToggles
        entity="cohorts"
        privateFlag={privateFlag}
        internalFlag={internalFlag}
        updateFlags={(flags) => updateFlags(category, code, flags)}
      />
)}
  />
);

const mapStateToProps = ({
  requests: { requests },
  workflows: { workflows },
}, ownProps) => {
  const { request } = resolveRequestWorkflow(requests, workflows, ownProps, newRequest(ownProps));
  const { cohorts } = request.steps;

  return (
    {
      filterTerm: cohorts.filter,
      internalFlag: cohorts.internalFlag,
      privateFlag: cohorts.privateFlag,
      publicFlag: cohorts.publicFlag,
      readErrors: cohorts.readErrors,
    }
  );
};

const mapDispatchToProps = {
  updateFlags: updateRequestCohortsFlags,
  updateFilterTerm: updateRequestCohortsFilter,
  fetchData: fetchRequestCohorts,
};

export default connect(mapStateToProps, mapDispatchToProps)(RequestCohortsFilters);
